import React, { useEffect, useState } from "react";
import "../../../styles/desktop/legendaCaixaDagua.css";
import caixa from "../../../assets/img/CaixaDagua.png";

const LegendaCaixadagua = ({ alarmes }) => {
    const [caixaDagua01, setCaixaDagua01] = useState({
        alto: false,
        normal: false,
        baixo: false,
    });

    useEffect(() => {
        const atualizarEstadoCaixas = () => {
            if (alarmes && alarmes.length > 0) {
                // Caixa d'água superior
                const statusCaixa01 = alarmes.find((alarme) => alarme.nome === "Baixo - Caixa Inferior");
                setCaixaDagua01({
                    alto: alarmes.some((alarme) => alarme.nome === "Alto - Caixa Inferior" && alarme.status),
                    normal: !statusCaixa01?.status && !alarmes.some((alarme) => alarme.nome === "Alto - Caixa Inferior" && alarme.status),
                    baixo: statusCaixa01?.status || false,
                });
            }
        };

        atualizarEstadoCaixas();
    }, [alarmes]);

    return (
        <>
            <h1 className="tituloCaixa">Nível Caixa D'água</h1>
            <div className="CampoCaixaDagua">

                {/* Caixa D'água Inferior */}
                <div className="caixaDagua01">
                    <img src={caixa} alt="CaixaDagua" className="imageCaixa" style={{ top: "2%", left: "35%" }} />
                    <p
                        className="textoCaixa"
                        style={{
                            top: "24.5%",
                            left: "37.15%",
                            width: "24.5%",
                            height: "21.5%",
                            backgroundColor: caixaDagua01.alto ? "red" : "transparent",
                            clipPath: "polygon(0% 0%, 100% 0%, 96.6% 100%, 3% 100%)",
                        }}
                    >
                        Extravazão
                    </p>
                    <p
                        className="textoCaixa"
                        style={{
                            top: "43%",
                            left: "37.79%",
                            width: "23.1%",
                            height: "24%",
                            backgroundColor: caixaDagua01.normal ? "green" : "transparent",
                            clipPath: "polygon(0% 0%, 100% 0%, 95.8% 100%, 4.7% 100%)",
                        }}
                    >
                        Normal
                    </p>
                    <p
                        className="textoCaixa"
                        style={{
                            top: "63%",
                            left: "38.85%",
                            width: "21.1%",
                            height: "24%",
                            backgroundColor: caixaDagua01.baixo ? "red" : "transparent",
                            clipPath: "polygon(0% 0%, 100% 0%, 96.3% 100%, 4.7% 100%)",
                        }}
                    >
                        Baixissímo
                    </p>
                    <h2 className="nomeCaixas" style={{ top: "90%", left: "37%" }}>
                        Caixa D'água Inferior
                    </h2>
                </div>
            </div>
        </>
    );
};

export default LegendaCaixadagua;
